module.exports = __webpack_public_path__ + "static/media/downloadAttachement.17825d91.svg";